import types from '../mutation-types';
import API from '../../api/editorFiles';
import AnalyticsHelper from '../../helper/AnalyticsHelper';
import { EDITOR_FILE_EVENTS } from '../../helper/AnalyticsHelper/events';

export const state = {
  files: [],
  uiFlags: {
    isCreating: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  create: async function createEditorFiles({ commit }, obj) {
    commit(types.SET_EDITOR_FILE_UI_FLAG, { isCreating: true });
    try {
      const response = await API.create(obj);
      AnalyticsHelper.track(EDITOR_FILE_EVENTS.CREATE);
      commit(types.ADD_EDITOR_FILE, response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error?.response?.data?.message;
      throw new Error(errorMessage);
    } finally {
      commit(types.SET_EDITOR_FILE_UI_FLAG, { isCreating: false });
    }
  },
};

export const mutations = {
  [types.SET_EDITOR_FILE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
